// Common language codes
export const LANGUAGES = {
    en: 'English',
    fr: 'French',
    es: 'Spanish',
    de: 'German',
    it: 'Italian',
    pt: 'Portuguese',
    ja: 'Japanese',
    zh: 'Chinese',
    ko: 'Korean',
    ru: 'Russian',
    ar: 'Arabic',
    nl: 'Dutch',
    sv: 'Swedish',
    no: 'Norwegian',
    da: 'Danish',
    fi: 'Finnish',
    pl: 'Polish',
    cs: 'Czech',
    el: 'Greek',
    tr: 'Turkish',
    he: 'Hebrew',
    sr: 'Serbian',
    hr: 'Croatian',
    uk: 'Ukrainian',
    th: 'Thai',
    vi: 'Vietnamese',
    id: 'Indonesian',
    ms: 'Malay',
    hi: 'Hindi',
};
//# sourceMappingURL=profile.types.js.map